import { render, staticRenderFns } from "./AccionesRentablesSection.vue?vue&type=template&id=06cad53c&scoped=true&"
import script from "./AccionesRentablesSection.vue?vue&type=script&lang=js&"
export * from "./AccionesRentablesSection.vue?vue&type=script&lang=js&"
import style0 from "./AccionesRentablesSection.vue?vue&type=style&index=0&id=06cad53c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cad53c",
  null
  
)

export default component.exports